<template>
  <default-box>
    <div class="d-flex align-items-center">
      <small-title
        class="flex-grow-1"
        no_margin
        :text="$t('dashboard.your_monthly_report')"/>
      <img class="icon-30" src="/images/menu/my_vacation_calendar.svg" alt="vacation">
    </div>
    <hr/>
    <div>
      <div class="d-flex align-items-center gap-2">
        <div>
          <gray-text>Місяць:</gray-text>
          <month-select
            thinner
            :selected_month="month-1"
            @changeMonth="(val) => month = val+1"
          />
        </div>
        <div>
          <gray-text>Рік:</gray-text>
          <year-input
            default_theme
            :value="year"
            @changeYear="(val) => year = val"/>
        </div>
      </div>
      <div class="row">
        <div class="col-6 mt-10">
          <div class="d-flex flex-column gap-1">
            <div><b>Site</b>: {{report.site}}</div>
            <div><b>HO</b>: {{report.ho}}</div>
            <div><b>Other</b>: {{report.other}}</div>
          </div>
        </div>
        <div class="col-6 mt-10">
          <div class="d-flex flex-column gap-1">
            <div><b>{{reason_if_no.paid_day_off}}</b>: {{report.paid_day_off}}</div>
            <div><b>{{reason_if_no.non_paid_day_off}}</b>: {{report.non_paid_day_off}}</div>
            <div><b>{{reason_if_no.sick_leave}}</b>: {{report.sick_leave}}</div>
          </div>
        </div>
      </div>
      <loader v-if="loading"/>
    </div>
  </default-box>
</template>

<script>

import GrayText from "../../../small_components/GrayText.vue";
import Loader from "../../../small_components/Loader.vue";
import dateMixin from "../../../../mixins/dateMixin";
import DefaultBox from "../../../slots/DefaultBox.vue";
import SmallTitle from "../../../small_components/SmallTitle.vue";
import MonthSelect from "../../../small_components/calendar/MonthSelect.vue";
import YearInput from "../../../small_components/calendar/YearInput.vue";
import {axiosUser} from "../../../../helpers/axios_requests";
import {REASON_IF_NO_OBJ, WORKING_STATUSES} from "../../../../helpers/constants";

export default {
  name: "UserMonthlyReports",
  mixins: [dateMixin],
  components: {
    YearInput,
    MonthSelect,
    SmallTitle,
    DefaultBox,
    Loader,
    GrayText
  },
  computed: {
    reason_if_no() {
      return REASON_IF_NO_OBJ;
    }
  },
  data() {
    return {
      loading: false,
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      report: {
        site: 0,
        ho: 0,
        other: 0,
        paid_day_off: 0,
        non_paid_day_off: 0,
        sick_leave: 0,
      },
    }
  },
  mounted() {
    this.fetchMonthlyReport()
  },
  methods: {
    fetchMonthlyReport() {
      this.loading = true
      setTimeout(() => {
        this.loading = false
      }, 1000)
      axiosUser.getMyMonthlyReport({
        year: this.year,
        month: this.month
      }).then(({data}) => {
        this.report.site = data[WORKING_STATUSES.site] || '-';
        this.report.ho = data[WORKING_STATUSES.ho] || '-';
        this.report.other = data[WORKING_STATUSES.other] || '-';
        this.report.paid_day_off = data[REASON_IF_NO_OBJ.paid_day_off] || '-';
        this.report.non_paid_day_off = data[REASON_IF_NO_OBJ.non_paid_day_off] || '-';
        this.report.sick_leave = data[REASON_IF_NO_OBJ.sick_leave] || '-';
      }).finally(() => {
        this.loading = false
      })
    },
  },
  watch: {
    'year'() {
      this.fetchMonthlyReport()
    },
    'month'() {
      this.fetchMonthlyReport()
    },
  }
}
</script>
